import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SkeletonLoaderComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-leads-card',
  standalone: true,
  imports: [CommonModule, SkeletonLoaderComponent],
  templateUrl: './leads-card.component.html',
  styleUrl: './leads-card.component.scss',
})
export class LeadsCardComponent {
  @Input() totalLeads!: string | number;
  @Input() dateRange!: { startDate: Date; endDate: Date };
  @Input() isLoading: boolean = false;
  @Input() title: string = 'Total Leads';
}
